import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { BreadcrumbsComponent } from './breadcrumbs.component';

@NgModule({
    imports: [SharedModule],
    declarations: [BreadcrumbsComponent],
    entryComponents: [BreadcrumbsComponent],
    exports: [BreadcrumbsComponent]
})
export class BreadcrumbsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/breadcrumbs/breadcrumbs.module.ts